import Button from "../layout/Button"

const stats = [
  { id: 1, name: 'Transactions every 24 hours', value: '44 million' },
  { id: 2, name: 'Assets under holding', value: '$119 trillion' },
  { id: 3, name: 'New users annually', value: '46,000' },
]

export default function SupportUs() {
  return (
    <div className="bg-yellow py-12 sm:py-20 relative">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 flex flex-wrap justify-center gap-8 lg:gap-20">
        <h1 className="text-2xl sm:text-4xl lg:text-6xl font-semibold text-dark-grey">Support us</h1>

        <div className="flex flex-row flex-nowrap gap-4">
          {/* Crowdfunding */}
          <Button
            bgColour="dark-grey"
            textColour="white"
            width="fit"
            paddingX="6"
            paddingY="0.5"
            onClick={() => window.open("https://www.crowdfunder.co.uk/p/raise-diversity", "_blank")}
          >
            <span className="">Crowdfunding</span>
          </Button>

          {/* Buy us a coffee */}
          <Button
            bgColour="dark-grey"
            textColour="white"
            width="fit"
            paddingX="6"
            paddingY="0.5"
            onClick={() =>
              // Open in new tab
              window.open("https://ko-fi.com/raisediversity", "_blank")
            }
          >
            <span className="">Buy us a coffee</span>
          </Button>
        </div>

      </div>

      {/* Bubbles */}
      <img
        src="/img/graphics/bubbles/bubble-top-orange.svg"
        alt="Bubble"
        className="absolute w-32 md:w-48 object-cover -top-10 right-40"
      />
    </div>
  )
}
